

export const quoteFlowConfig = {

  products: {
    conservatories: {
      id: 'conservatories',
      name: 'Conservatories & Extensions',
      steps: [
        'product-selection',
        'conservatory-style',
        'conservatory-roof-type',
        'conservatory-roof-dimensions',
        'summary'
      ],
      conditionalSteps: [
        {
          step: 'conservatory-roof-type',
          condition: (data) => {
            // Skip roof type selection for orangery styles
            return data.style !== 'orangery' && data.style !== 'contemporary-orangery';
          }
        }
      ]
    },

    windows: {
      id: 'windows',
      name: 'Windows',
      steps: [
        'product-selection',
        'window-style',
        'quantity',
        'colour',
        'hardware',
        'summary'
      ],
      conditionalSteps: [
        {
          step: 'hardware',
          condition: (data) => {
            // Remove hardware step for secondary glazing
            return data.style !== 'secondary-glazing';
          }
        }
      ]
    },

    'aluminium-windows': {
      id: 'aluminium-windows',
      name: 'Aluminium Windows',
      steps: [
        'product-selection',
        'window-style',
        'quantity',
        'colour',
        'hardware',
        'summary'
      ],
      conditionalSteps: []
    },

    'internal-products': {
      id: 'internal-products',
      name: 'Internal Doors and Windows',
      steps: [
        'product-selection',
        'internal-product-style',
        'quantity',
        'colour',
        'hardware',
        'summary'
      ],
      conditionalSteps: [
        {
          step: 'hardware',
          condition: (data) => {
            // Skip hardware for internal sliding doors
            return data.style !== 'internal-sliding-door';
          }
        }
      ]
    },

    'front-back-doors': {
      id: 'front-back-doors',
      name: 'Front & Back Doors',
      steps: [
        'product-selection',
        'door-style',
        'quantity',
        'colour',
        'hardware',
        'summary'
      ],
      conditionalSteps: []
    },

    'aluminium-doors': {
      id: 'aluminium-doors',
      name: 'Aluminium Doors',
      steps: [
        'product-selection',
        'door-style',
        'quantity',
        'colour',
        'hardware',
        'summary'
      ],
      conditionalSteps: []
    },

    'bifolding-sliding-french-doors': {
      id: 'bifolding-sliding-french-doors',
      name: 'Bifolding, Sliding and French Doors',
      steps: [
        'product-selection',
        'bifolding-door-style',
        'quantity',
        'colour',
        'hardware',
        'summary'
      ],
      conditionalSteps: [
        {
          step: 'hardware',
          condition: (data) => {
            // Skip hardware for uPVC sliding doors
            return data.style !== 'upvc-sliding-doors';
          }
        }
      ]
    },

    'verandas-pergolas': {
      id: 'verandas-pergolas',
      name: 'Verandas & Pergolas',
      steps: [
        'product-selection',
        'veranda-pergola-style',
        'dimensions',
        'colour',
        'summary'
      ],
      conditionalSteps: []
    },

    'conservatory-roofs': {
      id: 'conservatory-roofs',
      name: 'Conservatory Roofs',
      steps: [
        'product-selection',
        'new-roof-type',
        'conservatory-roof-dimensions',
        'summary'
      ],
      conditionalSteps: []
    }
  },


  stepConfig: {
    'product-selection': {
      title: 'Choose Your Product',
      component: 'ProductSelectionStep',
      validation: ['required']
    },


    'conservatory-style': {
      title: 'Choose Your Style',
      component: 'StyleSelectionStep',
      validation: ['required'],
      options: ['victorian', 'edwardian', 'lean-to', 'gable', 'p-shape', 'orangery', 'conservatory', 'contemporary-conservatory']
    },
    'conservatory-roof-type': {
      title: 'Select Roof Type',
      component: 'RoofTypeStep',
      validation: ['required'],
      options: ['glass', 'polycarbonate', 'solid', 'tiled']
    },
    'window-style': {
      title: 'Choose Window Style',
      component: 'StyleSelectionStep',
      validation: ['required'],
      hasSubOptions: true
    },


    'internal-product-style': {
      title: 'Choose Your Product',
      component: 'StyleSelectionStep',
      validation: ['required']
    },


    'door-style': {
      title: 'Choose Door Style',
      component: 'StyleSelectionStep',
      validation: ['required']
    },


    'bifolding-door-style': {
      title: 'Choose Your Style',
      component: 'StyleSelectionStep',
      validation: ['required']
    },


    'veranda-style': {
      title: 'Choose Veranda Style',
      component: 'StyleSelectionStep',
      validation: ['required']
    },
    'veranda-pergola-style': {
      title: 'Choose Your Type',
      component: 'StyleSelectionStep',
      validation: ['required']
    },
    'veranda-dimensions': {
      title: 'Enter Dimensions',
      component: 'VerandaDimensionsStep',
      validation: ['required'],
      fields: ['width', 'height', 'glazed']
    },


    'new-roof-type': {
      title: 'Select New Roof Type',
      component: 'NewRoofTypeStep',
      validation: ['required'],
      options: [
        'glass',
        'tiled',
        'hybrid',
        'lantern',
        'flat-skylight',
        'orangery-style'
      ]
    },
    'conservatory-roof-dimensions': {
      title: 'Enter Dimensions',
      component: 'ConservatoryRoofDimensionsStep',
      validation: ['required'],
      fields: ['width', 'height', 'newOrExisting']
    },


    'postcode': {
      title: 'Enter Your Postcode',
      component: 'PostcodeStep',
      validation: ['required', 'postcode']
    },
    'dimensions': {
      title: 'Enter Dimensions',
      component: 'DimensionsStep',
      validation: ['required'],
      fields: ['width', 'height']
    },
    'colour': {
      title: 'Choose Your Colour',
      component: 'ColourStep',
      validation: ['required']
    },
    'hardware': {
      title: 'Select Hardware Finish',
      component: 'HardwareStep',
      validation: ['required']
    },
    'quantity': {
      title: 'Share your requirements',
      component: 'QuantityStep',
      validation: ['required'],
      question: 'How many {productType} are you looking to replace/add?',
      options: ['1', '2', '3', '4', '5', '6+', 'I\'m not sure']
    },
    'summary': {
      title: 'Review Your Quote',
      component: 'SummaryStep',
      validation: []
    }
  }
};


export const getProductSteps = (productId, formData = {}) => {
  const product = quoteFlowConfig.products[productId];
  if (!product) return [];

  let steps = [...product.steps];


  if (product.conditionalSteps && product.conditionalSteps.length > 0) {
    steps = steps.filter(stepId => {
      const conditional = product.conditionalSteps.find(cs => cs.step === stepId);
      if (!conditional) return true;


      if (!conditional.condition) return true;

      return conditional.condition(formData);
    });
  }

  return steps;
};


export const getStepConfig = (stepId) => {
  return quoteFlowConfig.stepConfig[stepId];
};
